// 导入axios实例
import axiosInstance from './axiosInstance';

// 获取所有资源
export const getResources = (config) => axiosInstance.get('/tech-support/resources', config);

// 获取所有常见问题
export const getFaqs = (config) => axiosInstance.get('/tech-support/faqs', config);

// 创建新资源
export const createResource = (resourceData, config) => axiosInstance.post('/tech-support/resources', resourceData, config);

// 更新资源
export const updateResource = (id, resourceData, config) => axiosInstance.put(`/tech-support/resources/${id}`, resourceData, config);

// 删除资源
export const deleteResource = (id) => axiosInstance.delete(`/tech-support/resources/${id}`);

// 创建新常见问题
export const createFaq = (faqData) => axiosInstance.post('/tech-support/faqs', faqData);

// 更新常见问题
export const updateFaq = (id, faqData) => axiosInstance.put(`/tech-support/faqs/${id}`, faqData);

// 删除常见问题
export const deleteFaq = (id) => axiosInstance.delete(`/tech-support/faqs/${id}`);

// 上传文件
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/tech-support/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 文档相关API
export const getDocuments = (config) => {
  return axiosInstance.get('/tech-support/documents', config);
};

export const createDocument = (documentData) => {
  return axiosInstance.post('/tech-support/documents', documentData);
};

export const updateDocument = (id, documentData) => {
  return axiosInstance.put(`/tech-support/documents/${id}`, documentData);
};

export const deleteDocument = (id) => {
  return axiosInstance.delete(`/tech-support/documents/${id}`);
};

// 下载文件
export const downloadFile = (filename) => {
  return axiosInstance.get(`/tech-support/download/${filename}`, {
    responseType: 'blob'
  });
};